import React from "react";
import "./Spinner.css";

export const Spinner = () => {
  return (
    <div data-testid="spinner" className="loading-wave">
      <div className="loading-bar"></div>
      <div className="loading-bar"></div>
      <div className="loading-bar"></div>
      <div className="loading-bar"></div>
    </div>
  );
};
